import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\AiProducts\VerifyAiCustomerOtpController::__invoke
* @see Http/Controllers/Web/AiProducts/VerifyAiCustomerOtpController.php:21
* @route '/ai-products/register/verify-otp'
*/
const VerifyAiCustomerOtpController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: VerifyAiCustomerOtpController.url(options),
    method: 'post',
})

VerifyAiCustomerOtpController.definition = {
    methods: ["post"],
    url: '/ai-products/register/verify-otp',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\AiProducts\VerifyAiCustomerOtpController::__invoke
* @see Http/Controllers/Web/AiProducts/VerifyAiCustomerOtpController.php:21
* @route '/ai-products/register/verify-otp'
*/
VerifyAiCustomerOtpController.url = (options?: RouteQueryOptions) => {
    return VerifyAiCustomerOtpController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\AiProducts\VerifyAiCustomerOtpController::__invoke
* @see Http/Controllers/Web/AiProducts/VerifyAiCustomerOtpController.php:21
* @route '/ai-products/register/verify-otp'
*/
VerifyAiCustomerOtpController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: VerifyAiCustomerOtpController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\AiProducts\VerifyAiCustomerOtpController::__invoke
* @see Http/Controllers/Web/AiProducts/VerifyAiCustomerOtpController.php:21
* @route '/ai-products/register/verify-otp'
*/
const VerifyAiCustomerOtpControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: VerifyAiCustomerOtpController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\AiProducts\VerifyAiCustomerOtpController::__invoke
* @see Http/Controllers/Web/AiProducts/VerifyAiCustomerOtpController.php:21
* @route '/ai-products/register/verify-otp'
*/
VerifyAiCustomerOtpControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: VerifyAiCustomerOtpController.url(options),
    method: 'post',
})

VerifyAiCustomerOtpController.form = VerifyAiCustomerOtpControllerForm

export default VerifyAiCustomerOtpController